// Widget-Raster ohne Lücken (README §4.6): erst „dense“ setzen wie CSS-Grid, dann jedes Widget
// in freie Nachbarzellen nach rechts und unten wachsen lassen. CSS-Grid kann Widgets nicht
// verbreitern – ohne diesen Schritt entstehen neben und unter großen Widgets leere Flächen.

export interface PackElement { key: string; w: number; h: number }
/** Platz im Raster, 0-basiert. */
export interface Platz { key: string; spalte: number; zeile: number; w: number; h: number }

export function packeRaster(elemente: readonly PackElement[], spalten: number): Platz[] {
  const c = Math.max(1, Math.floor(spalten));
  const belegt: boolean[][] = [];
  const frei = (z: number, s: number) => !(belegt[z]?.[s]);
  const setze = (z: number, s: number) => { (belegt[z] ??= [])[s] = true; };

  // 1) dicht setzen: erste freie Stelle von oben links (wie grid-auto-flow: dense)
  const plaetze: Platz[] = elemente.map(e => {
    const w = Math.min(Math.max(1, e.w), c);
    const h = Math.max(1, e.h);
    for (let z = 0; ; z++) {
      for (let s = 0; s + w <= c; s++) {
        let passt = true;
        for (let dz = 0; dz < h && passt; dz++) for (let ds = 0; ds < w && passt; ds++) passt = frei(z + dz, s + ds);
        if (!passt) continue;
        for (let dz = 0; dz < h; dz++) for (let ds = 0; ds < w; ds++) setze(z + dz, s + ds);
        return { key: e.key, spalte: s, zeile: z, w, h };
      }
    }
  });

  // 2) Lücken füllen: erst alle in die Breite (bis zum Rand), dann in die Höhe (nur innerhalb
  //    der belegten Zeilen) – so wird z. B. „Einheiten“ breiter statt die Karte darüber höher.
  const zeilen = plaetze.reduce((m, p) => Math.max(m, p.zeile + p.h), 0);
  const breiter = (p: Platz) => {
    let mehr = false;
    while (p.spalte + p.w < c && Array.from({ length: p.h }, (_, i) => frei(p.zeile + i, p.spalte + p.w)).every(Boolean)) {
      for (let i = 0; i < p.h; i++) setze(p.zeile + i, p.spalte + p.w);
      p.w += 1; mehr = true;
    }
    return mehr;
  };
  const hoeher = (p: Platz) => {
    let mehr = false;
    while (p.zeile + p.h < zeilen && Array.from({ length: p.w }, (_, i) => frei(p.zeile + p.h, p.spalte + i)).every(Boolean)) {
      for (let i = 0; i < p.w; i++) setze(p.zeile + p.h, p.spalte + i);
      p.h += 1; mehr = true;
    }
    return mehr;
  };
  let geaendert = true;
  while (geaendert) {
    geaendert = plaetze.map(breiter).some(Boolean);
    if (!geaendert) geaendert = plaetze.map(hoeher).some(Boolean);
  }
  return plaetze;
}

/** Spaltenzahl wie repeat(auto-fill, minmax(min, 1fr)). */
export function spaltenFuer(breite: number, min = 150, abstand = 16): number {
  return Math.max(1, Math.floor((breite + abstand) / (min + abstand)));
}
